export default __webpack_public_path__ + "assets/fonts/3e95f3055b81a1011e23555869173191.woff";